<div class="example">
  <div [style.fontFamily]="fontFamily" class="table">
    <div class="row">
      <div
        [style.fontFamily]="fontFamily"
        class="row__text"
        msl-fit-text
        [heightCompression]="0.70"
        [minFontSize]="10"
        [maxFontSize]="200"
        [ngStyle]="{ color: textColor }"
        [innerHTML]="firstNumber"
      ></div>
    </div>
    <div class="row">
      <div
        [style.fontFamily]="fontFamily"
        msl-fit-text
        [heightCompression]="0.6"
        [minFontSize]="10"
        [maxFontSize]="120"
        class="operation"
      >{{ operation }}</div>
    </div>
    <div class="row">
      <div
        [style.fontFamily]="fontFamily"
        class="row__text"
        msl-fit-text
        [heightCompression]="0.70"
        [minFontSize]="10"
        [maxFontSize]="200"
        [ngStyle]="{ color: textColor }"
        [innerHTML]="secondNumber"
      ></div>
    </div>
  </div>
</div>
